/** Définition affichée au survol d'un mot du glossaire (cours et analyses). */
export default function GlossaryHover({ hover }) {
  if (!hover) return null;
  const width = 300;
  const left = Math.min(Math.max(12, hover.x - width / 2), window.innerWidth - width - 12);
  const above = hover.y > 200;
  return (
    <div
      className="fixed z-[70] rounded-lg border border-white/10 bg-[#121214] shadow-2xl p-3 pointer-events-none"
      style={{ width, left, top: above ? hover.top - 8 : hover.bottom + 8, transform: above ? "translateY(-100%)" : "none" }}
      role="tooltip"
    >
      <div className="text-[10px] uppercase tracking-[0.18em] text-orange-400">Glossaire</div>
      <div className="mt-0.5 font-semibold text-sm text-zinc-100">{hover.title}</div>
      <p className="mt-1 text-sm text-zinc-400 leading-relaxed">{hover.def}</p>
      <div className="mt-1.5 text-xs text-zinc-500">Cliquer pour lire la fiche</div>
    </div>
  );
}
